import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container, Sprite } from '@pixi/react';
import * as PIXI from 'pixi.js';
import { useMemo } from 'react';
import DEALER_BUTTON_IMAGE_URL from '../../../assets/dealer-button.png';
import { isTestEnvironment } from '../../../utils/utils';
export const DealerButton = ({ seatIndex, x, y, size }) => {
    const texture = useMemo(() => PIXI.Texture.from(DEALER_BUTTON_IMAGE_URL), []);
    const scale = size / texture.width;
    const containerX = Math.round(x - size / 2);
    const containerY = Math.round(y - size / 2);
    return (_jsx(Container, { "pixi-data": isTestEnvironment() ? { type: 'dealer-button', seatIndex } : null, interactiveChildren: false, x: containerX, y: containerY, scale: scale, children: _jsx(Sprite, { texture: texture }) }));
};
